module.exports = __webpack_public_path__ + "static/img/rectangularValveImg.6a962a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/rectangularValveImg.png
// module id = FfgW
// module chunks = 1